import React, { useEffect, useState } from 'react'
import ContentHeading from '../../../components/layout/content/ContentHeading'
import { Button, MenuItem, Typography } from '@mui/material'
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { OrganizationApi } from '../../../api/organization/organization.api';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../../store/tree-view/tree-view.slice';
import { EmployeeApi } from '../../../api/employee/employee.api';
import InputTextField from '../../../components/input/inputTextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { ButtonBack, ButtonDel, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import ModalCustom from '../../../components/modal/ModalCustom';
import FilterSelect from '../../../components/select/filterSelect';
import { ReactComponent as Iconfolder } from '../../../assets/icons/folder-2.svg'
import { ReactComponent as IconUser } from '../../../assets/icons/user-square.svg'
import { ReactComponent as Iconadd } from '../../../assets/icons/add.svg'
import { ReactComponent as Iconpassword } from '../../../assets/icons/password-check2.svg'
import { ReactComponent as Iconbag } from '../../../assets/icons/bag.svg'

import { colors_button } from '../../../components/button/util.button';
import { alertError, swalActive, swalSuccess } from '../../../components/alert/swal';
import { useTranslation } from 'react-i18next';
import AutocompleteSelect from '../../../components/select/autoCompleteSelect';
import { checkPermission, debouncedApiCall } from '../../../utils/app.utils';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import StateComponents from '../../../components/state-component/StateComponents';
import { RootState } from '../../../store/store';

type Props = {}
const RecursiveTreeView = ({ nodes }: any) => {
    const dispatch = useDispatch()
    return (
        <TreeItem sx={{
            color: '#828282',
            '.Mui-selected': {
                color: '#FCAF17 !important',
                backgroundColor: 'unset !important',
                '&:hover': {
                    backgroundColor: '#7e7e7e0d !important'
                },
                '& .MuiTreeItem-label': {
                    color: '#FCAF17 !important',
                    '& .MuiTypography-root': {
                        color: '#FCAF17 !important',
                    }
                }
            },

        }} onClick={() => dispatch(setData(nodes))} key={nodes.id_department} itemId={nodes.id_department.toString()} label={
            <div className='flex align-items-center gap-2'>
                <Iconfolder />
                <Typography >{nodes.department_name_th}</Typography>
            </div>}>
            {Array.isArray(nodes.children)
                ? nodes.children.map((node: any) => <RecursiveTreeView key={node.id_department} nodes={node} />)
                : null}
        </TreeItem>
    );
};

const TreeViewComponent = ({ treeData }: any) => {
    return (
        <SimpleTreeView>
            {treeData.map((node: any) => (
                <RecursiveTreeView key={node.id_department} nodes={node} />
            ))}
        </SimpleTreeView>
    );
};

const defaultFormDepartment = {
    id_department: 0,
    department_name_th: "",
    department_name_eng: "",
    status: "active",
    id_department_ref: 0
}


const OrganizationChartManagement = ({ }: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();



    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('OrganizationChartManagement', permission);


    const treeViewData = useSelector((state: any) => state?.treeViewData.data);
    const [formDepartment, setFormDepartment] = useState<any>(defaultFormDepartment)
    const [formEmployees, setFormEmployees] = useState<any>(null)
    const [keyword, setKeyword] = useState<string>('')
    const [openDepartment, setOpenDepartment] = useState<boolean>(false)
    const [openEmployees, setOpenEmployees] = useState<boolean>(false)
    const [openEditEmployees, setOpenEditEmployees] = useState<boolean>(false)
    const [isEditableDepartment, setIsEditableDepartment] = useState<boolean>(false);
    const [is_edit_department, set_is_edit_department] = useState<boolean>(false);

    const [tree, setTree] = useState<any[]>([])
    const [departmentDetail, setDepartmentDetail] = useState<any>()
    const [department, setDepartment] = useState<any[]>([])
    const [employees, setEmployees] = useState<any[]>([])
    const getTree = async () => {
        const param = { keyword: '' }
        const res = await OrganizationApi.tree(param)
        const data = res.data
        if (data.status < 300) {
            setTree(data.data);
        } else {
            setTree([])
        }

    }
    const getSearchTree = async () => {
        const param = { keyword: keyword }
        const res = await OrganizationApi.tree(param)
        const data = res.data
        if (data.status < 300) {
            setTree(data.data);
        } else {
            setTree([])
        }

    }
    const getDepartment = async () => {
        const param = { keyword: '' }
        const res = await OrganizationApi.list(param)
        const data = res.data
        if (data.status < 300) {
            setDepartment(data.data);
        } else {
            setDepartment([])
        }

    }
    const getEmployee = async (keyword?: string) => {
        const param = { limit: 100, search: keyword || '' }
        const res = await EmployeeApi.list(param)
        const data = res.data
        if (data.status < 300) {
            setEmployees(data.data.items);
        } else {
            setEmployees([])
        }

    }
    const getDepartmentDetail = async () => {
        const res = await OrganizationApi.detail(treeViewData?.id_department)
        const data = res.data
        if (data.status < 300) {
            setDepartmentDetail(data.data);
        } else {
            setDepartmentDetail(null)
        }

    }

    useEffect(() => {
        getDepartment()
        getTree()
        getEmployee()
    }, [])


    useEffect(() => {
        if (treeViewData?.id_department) {
            getDepartmentDetail()
        }
    }, [treeViewData])

    const handleCloseDepartment = async () => {
        setOpenDepartment(false)
        setFormDepartment(defaultFormDepartment)
        setIsEditableDepartment(false)
    }
    const handleCreateDepartment = async () => {
        const body = {
            id_department: formDepartment?.id_department || undefined,
            department_name_th: formDepartment.department_name_th || '',
            department_name_eng: formDepartment.department_name_eng || '',
            status: "active",
            id_department_ref: formDepartment.id_department_ref || undefined
        }
        dispatch(setLoading());
        if (formDepartment?.id_department) {
            await OrganizationApi.update(body, formDepartment.id_department).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('ORGANIZATION_CHART_MANAGEMENT.ALERT.SAVE_SUCCESS'))
                    getTree()
                    getDepartment()
                    handleCloseDepartment()
                    set_is_edit_department(false);
                }
            }).catch((error: any) => {
                console.log(error);
                alertError("บันทึกไม่สำเร็จ", error?.response?.data?.message || "")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await OrganizationApi.create(body).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('ORGANIZATION_CHART_MANAGEMENT.ALERT.CREATE_SUCCESS'))
                    getTree()
                    getDepartment()
                    handleCloseDepartment()
                    set_is_edit_department(false);
                }
            }).catch((error: any) => {
                alertError("บันทึกไม่สำเร็จ", error?.response?.data?.message || "")
                console.log(error);
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    const handleDeleteDepartment = async () => {
        swalActive(t('ORGANIZATION_CHART_MANAGEMENT.ALERT.DELETE_CONFIRM'), '', async () => {
            await OrganizationApi.delete(treeViewData.id_department).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('ORGANIZATION_CHART_MANAGEMENT.ALERT.DELETE_SUCCESS'))
                    getTree()
                    getDepartment()
                }
            }).catch((error: any) => console.log(error))
        }, 'question', t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_OK'))


    }
    const handleCloseEmployees = async () => {
        setOpenEmployees(false)
        setFormEmployees(null)
    }
    const handleCloseEditEmployees = async () => {
        setOpenEditEmployees(false)
        setFormEmployees(null)
    }
    const handleCreateEmployees = async (id?: number) => {
        const body = {
            Fullname: formEmployees?.newFullname
        }
        await OrganizationApi.updateEmployees(id || treeViewData.id_department, formEmployees.id_employee, formEmployees.id_employee === 0 ? body : undefined).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ORGANIZATION_CHART_MANAGEMENT.ALERT.SAVE_SUCCESS'))
                getTree()
                handleCloseEmployees()
                handleCloseEditEmployees()
                getDepartmentDetail()
            }
        }).catch((error: any) => console.log(error))
    }
    const handleDeleteEmployees = async () => {
        swalActive(t('ORGANIZATION_CHART_MANAGEMENT.ALERT.DELETE_CONFIRM'), '', async () => {
            await OrganizationApi.deleteEmployees(treeViewData.id_department, formEmployees.id_employee).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('ORGANIZATION_CHART_MANAGEMENT.ALERT.DELETE_SUCCESS'))
                    getTree()
                    getDepartmentDetail()
                }
            }).catch((error: any) => console.log(error))
        }, 'question', t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_OK'))
    }


    return (
        <div>
            <ContentHeading title={"TOPIC.ORGANIZATION_CHART_MANAGEMENT"} detail='HEADING.SELECT_LIST' />
            <div className='w-full grid grid-cols-12 gap-4 mt-[40px]'>

                <div className='col-span-12 md:col-span-12 lg:col-span-7 border-2 rounded-lg border-gray-300 relative h-[580px]'>
                    <div className='p-4'>
                        <Typography variant='h5'>{t('ORGANIZATION_CHART_MANAGEMENT.AGENCY')}</Typography>
                        <div className='p-4 h-[390px] overflow-auto'>
                            <TreeViewComponent treeData={tree} />
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row justify-center gap-4 mt-[40px] bg-[#DDE1EB] p-[46px] absolute bottom-0 left-0 right-0">
                        <div className="flex justify-center">
                            <InputTextField
                                startAdornment={<SearchOutlinedIcon sx={{ color: "#DDE1EB" }} />}
                                placeholder={t('ORGANIZATION_CHART_MANAGEMENT.SEARCH_DEPARTMENT_NAME_LASTNAME')}
                                value={keyword}
                                onchange={(e) => setKeyword(e.target.value)} />
                            <Button sx={{
                                background: colors_button.sky,
                                ':hover': {
                                    background: colors_button.sky,
                                },
                                color: "#fff",
                                marginLeft: '-10px',
                                width: "100px",
                                borderRadius: '0px 6px 6px 0px',
                                padding: '6px 12px'

                            }} onClick={() => getSearchTree()}><SearchOutlinedIcon className='me-1' />{t('ORGANIZATION_CHART_MANAGEMENT.SREACH')}</Button>
                        </div>
                        {checkPermit.isUpdate && (
                            <Button sx={{
                                background: colors_button.primary,
                                ':hover': {
                                    background: colors_button.primary,
                                },
                                color: "#fff",
                                borderRadius: '6px',
                                padding: '6px 12px',
                                whiteSpace: "nowrap"
                            }}
                                onClick={() => {
                                    setIsEditableDepartment(true)
                                    setFormDepartment(treeViewData)
                                    setOpenDepartment(true);
                                    set_is_edit_department(true);
                                }}><Iconpassword className='me-1' />{t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_EDIT_NAME')}</Button>
                        )}

                        {checkPermit.isDelete && (
                            <Button sx={{
                                background: colors_button.red,
                                ':hover': {
                                    background: colors_button.red,
                                },
                                color: "#fff",
                                borderRadius: '6px',
                                padding: '6px 12px'

                            }} onClick={() => {
                                handleDeleteDepartment()
                            }}><Iconbag className='me-1' />{t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_DELETE')}</Button>
                        )}
                        {checkPermit.isCreated && (
                            <Button sx={{
                                background: colors_button.success,
                                ':hover': {
                                    background: colors_button.success,
                                },
                                color: "#fff",
                                borderRadius: '6px',
                                padding: '6px 12px'

                            }} onClick={() => {
                                setOpenDepartment(true)
                            }}><Iconadd className='me-1' />{t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_ADD')}</Button>
                        )}

                    </div>
                </div>
                <div className='col-span-12 md:col-span-12 lg:col-span-5 border-2 rounded-lg border-gray-300 relative h-[580px]'>
                    <div className='p-4'>
                        <Typography variant='h5'>{t('ORGANIZATION_CHART_MANAGEMENT.CONTACT_INFORMATION')}</Typography>
                        <div className='p-4 h-[390px] overflow-auto'>
                            {departmentDetail?.employees?.map((item: any) => {
                                const emp = employees?.find((x: any) => item.id_employee === x.id_employee)
                                return (
                                    <div className='flex flex-col lg:flex-row align-items-center justify-between gap-2 mt-[10px] cursor-pointer' onClick={() => {
                                        setFormEmployees({ ...item, position_name: emp?.position_name, employee_no: emp?.employee_no })
                                    }} style={{
                                        color: formEmployees?.id_employee === item?.id_employee ? '#FCAF17' : '#4A4A4A'
                                    }}>
                                        <div className='flex align-items-center gap-2' >
                                            <IconUser />
                                            <Typography sx={{
                                                color: formEmployees?.id_employee === item?.id_employee ? '#FCAF17' : '#4A4A4A'
                                            }}>{item?.title || ''} {item?.first_name || ''} {item?.last_name || ''}</Typography>
                                        </div>
                                        <Typography sx={{
                                            color: formEmployees?.id_employee === item?.id_employee ? '#FCAF17' : '#4A4A4A'
                                        }}>{t('ORGANIZATION_CHART_MANAGEMENT.POSITION')} : {item?.position_name || emp?.position_name}</Typography>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row justify-center gap-4 mt-[40px] bg-[#DDE1EB] p-[46px] absolute bottom-0 left-0 right-0">

                        {checkPermit.isDelete && (
                            <>
                                {formEmployees?.id_department &&
                                    <Button sx={{
                                        background: colors_button.red,
                                        ':hover': {
                                            background: colors_button.red,
                                        },
                                        color: "#fff",
                                        borderRadius: '6px',
                                        padding: '6px 12px'

                                    }} onClick={() => {
                                        handleDeleteEmployees()
                                    }}><Iconbag className='me-1' />{t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_DELETE')}</Button>}
                            </>
                        )}
                        {checkPermit.isCreated && (
                            <Button sx={{
                                background: colors_button.success,
                                ':hover': {
                                    background: colors_button.success,
                                },
                                color: "#fff",
                                borderRadius: '6px',
                                padding: '6px 12px'

                            }} onClick={() => {
                                setOpenEmployees(true)
                                setFormEmployees(null)
                            }}><Iconadd className='me-1' />{t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_ADD')}</Button>
                        )}

                        {checkPermit.isUpdate && (
                            <>
                                {formEmployees?.id_department &&
                                    <Button
                                        // disabled={!formEmployees?.id_employee}
                                        sx={{
                                            background: colors_button.primary,
                                            ':hover': {
                                                background: colors_button.primary,
                                            },
                                            color: "#fff",
                                            borderRadius: '6px',
                                            padding: '6px 12px',
                                            whiteSpace: "nowrap"
                                        }} onClick={() => {
                                            setOpenEditEmployees(true);
                                            set_is_edit_department(true);
                                        }}><Iconpassword className='me-1' />{t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_EDIT_NAME')}</Button>}
                            </>
                        )}

                    </div>
                </div>
            </div>
            <ModalCustom title={is_edit_department ? "แก้ไขหน่วยงาน" : t('ORGANIZATION_CHART_MANAGEMENT.ADD_DEPARTMENT')} subTitle={t('ORGANIZATION_CHART_MANAGEMENT.SUBTITLE')} open={openDepartment} component={
                <div className='flex flex-col gap-4'>
                    <div>

                        <StateComponents
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12
                                    },
                                    fieldProps: {
                                        heading: t('ORGANIZATION_CHART_MANAGEMENT.UNDER_AGENCY'),
                                        getOptionLabel: (op) => op?.department_name_th || "",
                                        labelId: "id_department_ref",
                                        onChange: (_, val) => {
                                            setFormDepartment({
                                                ...formDepartment,
                                                id_department_ref: val?.id_department || null
                                            })
                                        },
                                        placeholder: t('ORGANIZATION_CHART_MANAGEMENT.SPECIFY_POSITION'),
                                        options: department.filter((x) => treeViewData?.id_department) || [],
                                        value: department.filter((x) => treeViewData?.id_department)?.find((x) => x?.id_department == formDepartment?.id_department_ref) || null,
                                        disabled: isEditableDepartment

                                    }
                                }
                            ]}
                        />

                        {/* <FilterSelect heading={t('ORGANIZATION_CHART_MANAGEMENT.UNDER_AGENCY')} placeholder={t('ORGANIZATION_CHART_MANAGEMENT.SPECIFY_POSITION')} labelId={''} selectId={''}
                            options={department.filter((x) => treeViewData?.id_department).map((x) => {
                                return (
                                    <MenuItem value={x.id_department} key={x.id_department_ref}>
                                        {x.department_name_th}
                                    </MenuItem>
                                )
                            })}
                            value={formDepartment?.id_department_ref}
                            onchange={(e) => setFormDepartment({ ...formDepartment, id_department_ref: e.target.value })}
                            disabled={isEditableDepartment} /> */}
                    </div>

                    <div>
                        <InputTextField
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.NAME_ORGANIZATION')}
                            placeholder={t('ORGANIZATION_CHART_MANAGEMENT.SPECIFY_NAME_ORGANIZATION')}
                            value={formDepartment?.department_name_th}
                            required
                            onchange={(e) => setFormDepartment({ ...formDepartment, department_name_th: e.target.value })}
                            disabled={isEditableDepartment}
                        />
                    </div>

                    <div>
                        <InputTextField
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.NAME_ORGANIZATION_EN')}
                            placeholder={t('ORGANIZATION_CHART_MANAGEMENT.SPECIFY_NAME_ORGANIZATION_EN')}
                            value={formDepartment?.department_name_eng}
                            required
                            onchange={(e) => setFormDepartment({ ...formDepartment, department_name_eng: e.target.value })}
                            disabled={isEditableDepartment}
                        />
                    </div>

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleCloseDepartment();
                                set_is_edit_department(false);
                            }}
                            buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_CANCEL')}
                        />
                        {checkPermit.isCreated || checkPermit.isUpdate && (
                            <>
                                {!isEditableDepartment ?
                                    <ButtonPrimary
                                        onClick={() => handleCreateDepartment()}
                                        mode='add'
                                        disabled={!formDepartment?.department_name_th || !formDepartment?.department_name_eng}
                                        buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_CONFIRM')}
                                    /> :
                                    <ButtonPrimary
                                        onClick={() => setIsEditableDepartment(false)}
                                        buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_EDIT')}
                                    />
                                }
                            </>
                        )}


                    </div>
                </div>
            } />
            <ModalCustom title={t('ORGANIZATION_CHART_MANAGEMENT.ADD_PERSON')} subTitle={t('ORGANIZATION_CHART_MANAGEMENT.SUBTITLE')} open={openEmployees} component={
                <div className='flex flex-col gap-4'>
                    <div>
                        <AutocompleteSelect
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.SEARCH_NAME_LASTNAME')} placeholder={t('ORGANIZATION_CHART_MANAGEMENT.SEARCH_NAME_LASTNAME_IDENTIFICATION_NUMBER')}
                            freeSolo
                            labelId={''}
                            options={employees}
                            getOptionLabel={(option: any) => `${option?.fullname}||~~${option?.employee_no || '-'}` || ""}
                            onChange={(e: any, value: any) => {
                                setFormEmployees({ ...formEmployees, id_employee: value?.id_employee || 0, employee_no: value?.employee_no, position_name: value?.position_name })
                            }}
                            renderOption={(props, option) => (
                                <li {...props}>
                                    {`${option?.fullname} (${option?.employee_no || '-'})`}
                                </li>
                            )}
                            onInputChange={(e: any, value: any) => {
                                debouncedApiCall({ searchItem: value, setItem: getEmployee })
                                setFormEmployees({ ...formEmployees, id_employee: 0, employee_no: '', position_name: '', newFullname: value })
                            }} />
                    </div>
                    <div>
                        <InputTextField
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.IDENTIFICATION_NUMBER')}
                            placeholder={t('ORGANIZATION_CHART_MANAGEMENT.IDENTIFICATION_NUMBER')}
                            value={formEmployees?.employee_no || ''}
                            onchange={(e) => setFormEmployees({ ...formEmployees, employee_no: e.target.value })}
                            disabled
                        />
                    </div>

                    <div>
                        <InputTextField
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.POSITION')}
                            placeholder={t('ORGANIZATION_CHART_MANAGEMENT.POSITION')}
                            value={formEmployees?.position_name || ''}
                            onchange={(e) => setFormEmployees({ ...formEmployees, position_name: e.target.value })}
                            disabled
                        />
                    </div>

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleCloseEmployees()
                            }}
                            buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_CANCEL')}
                        />
                        {!isEditableDepartment ? <ButtonPrimary
                            onClick={() => handleCreateEmployees()}
                            mode='add'
                            disabled={!formEmployees?.id_employee}
                            buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_CONFIRM')}
                        /> : <>
                            <ButtonPrimary
                                onClick={() => setIsEditableDepartment(false)}
                                buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_EDIT')}
                            />
                            <ButtonDel
                                onClick={() => { handleDeleteDepartment() }}
                                buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_DELETE')}
                            /></>}

                    </div>
                </div>
            } />
            <ModalCustom title={t('ORGANIZATION_CHART_MANAGEMENT.CHANGE_WORK_LINE')} subTitle={t('ORGANIZATION_CHART_MANAGEMENT.SUBTITLE')} open={openEditEmployees} component={
                <div className='flex flex-col gap-4'>
                    <div>
                        <InputTextField
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.OFFICER_NAME')}
                            placeholder={t('ORGANIZATION_CHART_MANAGEMENT.OFFICER_NAME')}
                            value={`${formEmployees?.title || ''} ${formEmployees?.first_name} ${formEmployees?.last_name}`}
                            disabled
                        />
                    </div>
                    <div>
                        <InputTextField
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.IDENTIFICATION_NUMBER')}
                            placeholder={t('ORGANIZATION_CHART_MANAGEMENT.IDENTIFICATION_NUMBER')}
                            value={formEmployees?.employee_no || ''}
                            disabled
                        />
                    </div>
                    <div>
                        <InputTextField
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.POSITION')}
                            placeholder={t('ORGANIZATION_CHART_MANAGEMENT.POSITION')}
                            value={formEmployees?.position_name || ''}
                            disabled
                        />
                    </div>
                    <div>
                        <InputTextField
                            heading={t('ORGANIZATION_CHART_MANAGEMENT.CURRENT_ORGANIZATION')}
                            placeholder={t('ORGANIZATION_CHART_MANAGEMENT.POSITION')}
                            value={treeViewData?.department_name_th || ''}
                            disabled
                        />
                    </div>
                    <div>
                        <FilterSelect heading={t('ORGANIZATION_CHART_MANAGEMENT.ORGANIZATION_TO_MOVE')} placeholder={t('ORGANIZATION_CHART_MANAGEMENT.FIND_NEED_TO_MOVE')} labelId={''} selectId={''}
                            options={department.map((x) => {
                                return (
                                    <MenuItem value={x.id_department} key={x.id_department_ref}>
                                        {x.department_name_th}
                                    </MenuItem>
                                )
                            })}
                            value={formEmployees?.id_department_new}
                            onchange={(e) => setFormEmployees({ ...formEmployees, id_department: e.target.value, id_department_new: e.target.value })} />
                    </div>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleCloseEditEmployees()
                            }}
                            buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_CANCEL')}
                        />
                        {checkPermit.isCreated && (
                            <ButtonPrimary
                                onClick={() => handleCreateEmployees(formEmployees?.id_department)}
                                mode='add'
                                buttonName={t('ORGANIZATION_CHART_MANAGEMENT.COMMON.BUTTON_CONFIRM')}
                            />
                        )}
                    </div>
                </div>
            } />
        </div>
    )
}

export default OrganizationChartManagement